<template>
    <div class="row">
        <div class="small-12 columns" :class="{ error: showPhishingDamageAmountErrorText }">
            <label>
                Höhe der unautorisierten Überweisung
                <currency-input v-model="formData.phishing_damage_amount" :options="viewData.currencyInputOptions"/>
            </label>
            <small class="error" v-if="showPhishingDamageAmountErrorText">
                {{ phishingDamageAmountErrorText }}
            </small>
        </div>
        <div class="small-12 columns" :class="{ error: showPhishingDateErrorText }">
            <label>
                Datum der unautorisierten Überweisung
                <Datepicker
                    v-model="formData.phishing_date"
                    :upper-limit="viewData.datepickerOptions.upperLimit"
                    :input-format="viewData.datepickerOptions.inputFormat"
                    :locale="viewData.datepickerOptions.locale"
                    placeholder="Bitte Datum wählen..."
                />
            </label>
            <small class="error" v-if="showPhishingDateErrorText">
                {{ phishingDateErrorText }}
            </small>
        </div>
    </div>
</template>

<script>
import TypeHelper from '../../helper/TypeHelper';
import Validation from '../../helper/Validation';
import de from 'date-fns/locale/de';
import CurrencyInput from '../CurrencyInput';
import Datepicker from 'vue3-datepicker';

export default {
    name: 'PhishingDataFormStep',
    components: { CurrencyInput, Datepicker },
    props: {
        caseData: {
            type: Object,
            default: function()
            {
                return {
                    account_type:                                   null,
                    account_number:                                 null,
                    bank_name:                                      null,
                    bank_mail:                                      null,
                    main_account_holder_lawform:                    null,
                    main_account_holder_prename:                    null,
                    main_account_holder_surname:                    null,
                    main_account_holder_mail:                       null,
                    main_account_holder_company_name:               null,
                    is_main_account_holder_minor:                   null,
                    main_account_holder_payment_account_number:     null,
                    has_sub_account_holder:                         null,
                    sub_account_holder_lawform:                     null,
                    sub_account_holder_surname:                     null,
                    sub_account_holder_prename:                     null,
                    is_allowed_representor:                         null,
                    phishing_damage_amount:                         null,
                    phishing_date:                                  null
                }
            }
        }
    },
    data: () => ({
        formData: {
            phishing_damage_amount:                         null,
            phishing_date:                                  null
        },
        validation: {
            isFormDirty: false,
            isPhishingDamageAmountDirty: false,
            isPhishingDateDirty: false
        },
        viewData: {
            currencyInputOptions: {
                "currency": "EUR",
                "currencyDisplay": "symbol",
                "valueRange": {
                    "min": 0
                },
                "hideCurrencySymbolOnFocus": true,
                "hideGroupingSeparatorOnFocus": true,
                "hideNegligibleDecimalDigitsOnFocus": true,
                "autoDecimalDigits": false,
                "autoSign": true,
                "useGrouping": true,
                "accountingSign": false
            },
            datepickerOptions: {
                upperLimit: new Date(),
                inputFormat: 'dd.MM.yyyy',
                locale: de
            }
        }
    }),
    computed: {
        showPhishingDamageAmountErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isPhishingDamageAmountDirty)
                && TypeHelper.isNotNullOrUndefined(this.phishingDamageAmountErrorText);
        },
        phishingDamageAmountErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.formData.phishing_damage_amount, validators);
        },
        showPhishingDateErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isPhishingDateDirty)
                && TypeHelper.isNotNullOrUndefined(this.phishingDateErrorText);
        },
        phishingDateErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.formData.phishing_date, validators);
        },
    },
    methods: {
        validate()
        {
            this.validation.isFormDirty = true;

            this.emitValidity();
        },
        emitValidity()
        {
            this.$emit('updateValidity', this.isFormValid());
        },
        isFormValid()
        {
            let isValid = true;
            isValid = isValid && (this.phishingDamageAmountErrorText === null);
            isValid = isValid && (this.phishingDateErrorText === null);

            return isValid;
        },
        emitChangedData()
        {
            this.$emit('changeCaseData', this.formData);
        }
    },
    watch: {
        'formData.phishing_damage_amount': function()
        {
            this.validation.isPhishingDamageAmountDirty = true;
        },
        'formData.phishing_date': function()
        {
            this.validation.isPhishingDateDirty = true;
        },
        formData: {
            handler: function()
            {
                this.emitChangedData();
                this.emitValidity();
            },
            deep: true
        },
    }
};
</script>

<style scoped>
    .error label {
        color: #4d4d4d;
    }

    .v3dp__datepicker {
        --vdp-hover-bg-color: #e10065;
        --vdp-selected-bg-color: #e10065;
    }
</style>